import React, { Fragment, useState, useCallback, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { tableColumns } from './LessonData';
import { Button, Form, Modal } from 'react-bootstrap';
// import axios from 'axios';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
import CreateLesson from './CreateLesson';
import EditLesson from './EditLesson';
import BackIcon from '../../assets/images/svg/back.svg';
import EditIcon from '../../assets/images/svg/editLearning.svg';
import ArchiveIcon from '../../assets/images/svg/archiveLearning.svg';
import ArchiveEnabled from '../../assets/images/svg/archiveEnabled.svg';
import Search from '../../assets/images/svg/Search_SoS.svg';
import SearchIcon from '../../assets/images/svg/search_iconSos.svg';
import Calendar from '../../assets/images/svg/Calendar_SoS.svg';
import Filter from '../../assets/images/svg/Filter_SoS.svg';

// Import date range picker
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { _axios } from '../../utils/axios';

const LessonTable = () => {
    const { chapterId } = useParams();
    const navigate = useNavigate();

    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelete, setToggleDelete] = useState(false);
    const [data, setData] = useState([]);
    const [showCreate, setShowCreate] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [editRowData, setEditRowData] = useState(null);
    const [chapterInfo, setChapterInfo] = useState({ title: '', course_id: '', course_name: '' });
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [modalConfig, setModalConfig] = useState({
        type: '',
        lessonId: null
    });
    const [showIntroModal, setShowIntroModal] = useState(false);

    // New state variables for search, calendar, and filter functionality
    const [originalData, setOriginalData] = useState([]);
    const [showSearch, setShowSearch] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const searchRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [showCalendar, setShowCalendar] = useState(false);
    const calendarRef = useRef(null);
    const [dateRange, setDateRange] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection'
        }
    ]);
    const filterOptions = [
        { label: 'All', value: 'all' },
        { label: 'New', value: 'NEW' },
        { label: 'Active', value: 'ACTIVE' },
        { label: 'Archived', value: 'ARCHIVED' }
    ];

    // Click outside handlers for search, dropdown, and calendar
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSearch(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setShowCalendar(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Fetch data from API
    const fetchData = async () => {
        try {
            setLoading(true);

            let chapterData = null;
            let courseData = null;
            // First get chapter info
            const chapterResponse = await _axios.get(`${ServerPath}/chapter/${chapterId}`);

            if (chapterResponse.data.success) {
                chapterData = chapterResponse.data.data;

                // Now get course info to display the course name
                const courseResponse = await _axios.get(`${ServerPath}/course/${chapterData.course_id}`);

                if (courseResponse.data.success) {
                    courseData = courseResponse.data.data;
                    setChapterInfo({
                        title: chapterData.title,
                        course_id: chapterData.course_id,
                        course_name: courseData.title
                    });
                }
            }

            // Get lessons for this chapter
            const response = await _axios.get(`${ServerPath}/lesson/chapter/${chapterId}`);

            if (response.data.success && chapterData && courseData) {
                const transformedData = response.data.data.map(item => ({
                    id: item.lesson_id,
                    lesson_id: item.lesson_id,
                    chapter_id: item.chapter_id,
                    chapter_name: chapterData.title,
                    course_name: courseData.title,
                    course_id: chapterInfo.course_id,
                    content_id: item.content_id,
                    title: item.title,
                    description: item.description,
                    sequence_number: item.sequence_number,
                    is_introduction: item.is_introduction,
                    content_type: item.content_type || 'Unknown',
                    file_path: item.file_path,
                    duration_seconds: item.duration_seconds,
                    created_date: formatDate(item.created_at),
                    status: formatStatus(item.status),
                    status_component: getStatusBadge(formatStatus(item.status)),
                    action: (
                        <div className="d-flex justify-content-center gap-2">
                            <button
                                className="btn btn-link p-0"
                                title="Edit"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEdit({
                                        raw_data: item
                                    });
                                }}
                            >
                                <img src={EditIcon} alt="edit" style={{ width: '24px', height: '24px' }} />
                            </button>
                            <div title={item.status === 'Archived' ? "Archived" : "Archive"}>
                                <button
                                    className="btn btn-link p-0"
                                    disabled={item.status === 'Archived'}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (item.status !== 'Archived') {
                                            setModalConfig({
                                                type: 'archive',
                                                lessonId: item.lesson_id
                                            });
                                            setShowModal(true);
                                        }
                                    }}
                                    style={{ opacity: item.status === 'Archived' ? 0.5 : 1 }}
                                >
                                    <img src={item.status === 'Archived' ? ArchiveEnabled : ArchiveIcon} alt="archive" style={{ width: '24px', height: '24px' }} />
                                </button>
                            </div>
                        </div>
                    ),
                    raw_data: item // Store the original data for edit purposes
                }));

                setData(transformedData);
                setOriginalData(transformedData); // Store original data for filtering
                setTotalRows(transformedData.length);
            }
        } catch (error) {
            console.error('Error fetching lessons:', error);
            toast.error('Failed to fetch lessons');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [chapterId, currentPage, perPage]);

    // Helper functions for data formatting
    const formatStatus = (status) => {
        if (!status) return 'New';
        return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    };

    const getStatusBadge = (status) => {
        const statusMap = {
            'New': {
                backgroundColor: '#FFC107',
                color: '#FFFFFF'
            },
            'Active': {
                backgroundColor: '#00C853',
                color: '#FFFFFF'
            },
            'Archived': {
                backgroundColor: '#8B5CF6',
                color: '#FFFFFF'
            }
        };

        const style = statusMap[status] || statusMap['New'];

        return (
            <span className="d-inline-block"
                style={{
                    minWidth: '70px',
                    textAlign: 'center',
                    borderRadius: '20px',
                    padding: '4px 8px',
                    backgroundColor: style.backgroundColor,
                    color: style.color,
                    fontSize: '10px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.1)'
                }}
            >
                {status}
            </span>
        );
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    // Search, filter and date range functions
    const handleSearch = (value) => {
        setSearchValue(value);
        // Get the current date range if it exists
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(value, selectedFilter, currentDateRange);
    };

    const handleFilterChange = (value) => {
        setSelectedFilter(value);
        // Get the current date range if it exists
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(searchValue, value, currentDateRange);
        setShowDropdown(false);
    };

    const handleDateRangeChange = (item) => {
        console.log('Date Range Selected:', item.selection);
        setDateRange([item.selection]);
        applyFiltersAndSearch(searchValue, selectedFilter, item.selection);
    };

    const clearDateFilter = () => {
        const clearedRange = {
            startDate: null,
            endDate: null,
            key: 'selection'
        };
        setDateRange([clearedRange]);
        applyFiltersAndSearch(searchValue, selectedFilter, null);
        setShowCalendar(false);
    };

    const applyFiltersAndSearch = (searchValue, filterValue, dateValue) => {
        let filteredData = [...originalData];

        // Apply search filter
        if (searchValue && searchValue.trim()) {
            const searchTerm = searchValue.toLowerCase();
            filteredData = filteredData.filter(item => {
                return (
                    String(item.lesson_id || '').toLowerCase().includes(searchTerm) ||
                    String(item.title || '').toLowerCase().includes(searchTerm) ||
                    String(item.description || '').toLowerCase().includes(searchTerm) ||
                    String(item.content_type || '').toLowerCase().includes(searchTerm) ||
                    String(item.sequence_number || '').toLowerCase().includes(searchTerm) ||
                    String(item.status || '').toLowerCase().includes(searchTerm)
                );
            });
        }

        // Apply status filter
        if (filterValue && filterValue !== 'all') {
            filteredData = filteredData.filter(item => {
                const rawStatus = item.raw_data?.status || '';
                return rawStatus.toUpperCase() === filterValue.toUpperCase();
            });
        }

        // Apply date filter
        if (dateValue?.startDate && dateValue?.endDate) {
            filteredData = filteredData.filter(item => {
                const createdDate = new Date(item.raw_data.created_at);
                
                // Set time to start of day for consistent comparison
                const startDate = new Date(dateValue.startDate);
                startDate.setHours(0, 0, 0, 0);

                // Set time to end of day for consistent comparison
                const endDate = new Date(dateValue.endDate);
                endDate.setHours(23, 59, 59, 999);

                return createdDate >= startDate && createdDate <= endDate;
            });
        }

        setData(filteredData);
    };

    const handleViewContent = (lesson) => {
        // Handle viewing lesson content (e.g., video player, PDF viewer, etc.)
        if (lesson.file_path) {
            window.open(lesson.file_path, '_blank');
        } else {
            toast.info('No content available for this lesson');
        }
    };

    const handleEdit = (row) => {
        if (!row) return;
        console.log("Data we have for editing:", row);

        const rawData = row.raw_data;
        if (!rawData) return;

        // Get the latest lesson data before opening the edit modal
        _axios.get(`${ServerPath}/lesson/${rawData.lesson_id}`)
            .then(response => {
                if (response.data.success) {
                    const freshLessonData = response.data.data;

                    // Merge the latest data with what we already have
                    setEditRowData({
                        ...rawData,
                        ...freshLessonData,
                        title: freshLessonData.title || rawData.title,
                        description: freshLessonData.description || rawData.description,
                        content_id: freshLessonData.content_id || rawData.content_id,
                        status: freshLessonData.status || rawData.status,
                        created_at: freshLessonData.created_at || rawData.created_at,
                        updated_at: freshLessonData.updated_at
                    });
                    setShowEdit(true);
                } else {
                    toast.error('Failed to get latest lesson data');
                }
            })
            .catch(error => {
                console.error('Error fetching latest lesson data:', error);

                // Fall back to using the data we already have
                setEditRowData({
                    title: rawData.title,
                    description: rawData.description,
                    content_id: rawData.content_id,
                    status: rawData.status,
                    lesson_id: rawData.lesson_id,
                    chapter_id: rawData.chapter_id,
                    sequence_number: rawData.sequence_number,
                    is_introduction: rawData.is_introduction,
                    created_at: rawData.created_at,
                    updated_at: rawData.updated_at
                });
                setShowEdit(true);
            });
    };

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };

    const handleEditClose = () => {
        setShowEdit(false);
        setEditRowData(null);
        fetchData();
    };

    const handleCreateClose = () => {
        setShowCreate(false);
        fetchData();
    };

    const handleIntroClose = () => {
        setShowIntroModal(false);
        fetchData();
    };

    const handleGoBack = () => {
        navigate(`/course/${chapterInfo.course_id}/chapters`); // Navigate back to chapters page
    };

    const handleModalConfirm = async () => {
        try {
            if (modalConfig.type === 'archive') {
                const response = await _axios.put(`${ServerPath}/lesson/status`, {
                    lesson_id: modalConfig.lessonId,
                    status: 'Archived'
                });

                if (response.data.success) {
                    toast.success('Lesson has been successfully archived');
                    fetchData();
                }
            }
        } catch (error) {
            console.error('Error archiving lesson:', error);
            toast.error('Failed to archive lesson');
        }
        setShowModal(false);
    };

    return (
        <Fragment>
            <Container fluid={true} className="p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center">
                        <Button
                            variant="outline-secondary"
                            className="me-3"
                            onClick={handleGoBack}
                        >
                            <img src={BackIcon} alt="back" style={{ width: '16px', height: '16px' }} />
                            {/* <span className="ms-1">Back to Chapters</span> */}
                        </Button>
                        <h5 className="m-0">Courses - Lessons</h5>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                        {/* Search Component */}
                        <div className="position-relative" ref={searchRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowSearch(true)}
                            >
                                <img src={Search} alt="search" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showSearch && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '45px',
                                        left: '-180px',
                                        width: '220px',
                                        zIndex: 1000
                                    }}
                                >
                                    <div
                                        style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                            padding: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                background: '#F8F7FA',
                                                borderRadius: '6px',
                                                padding: '6px 12px'
                                            }}
                                        >
                                            <input
                                                type="text"
                                                placeholder="Search Here..."
                                                value={searchValue}
                                                onChange={(e) => handleSearch(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    border: 'none',
                                                    background: 'transparent',
                                                    fontSize: '14px',
                                                    color: '#666',
                                                    outline: 'none'
                                                }}
                                                autoFocus
                                            />
                                            <button
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                                onClick={() => handleSearch(searchValue)}
                                            >
                                                <img src={SearchIcon} alt="search" style={{ width: '20px', height: '20px' }} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Calendar Component */}
                        <div className="position-relative" ref={calendarRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowCalendar(!showCalendar)}
                            >
                                <img src={Calendar} alt="calendar" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showCalendar && (
                                <div
                                    className="position-absolute end-0 mt-2 bg-white rounded shadow p-3"
                                    style={{
                                        width: 'auto',
                                        maxWidth: '300px',
                                        zIndex: 1000,
                                        right: 0
                                    }}
                                >
                                    <style>
                                        {`
                                        .date-range {
                                            font-size: 12px !important;
                                        }
                                        .date-range .rdrMonth {
                                            width: 240px !important;
                                            padding: 0 !important;
                                        }
                                        .date-range .rdrCalendarWrapper {
                                            font-size: 12px !important;
                                            width: 240px !important;
                                            border-radius: 8px !important;
                                            overflow: hidden !important;
                                            background: white !important;
                                        }
                                        .date-range .rdrDateDisplayWrapper {
                                            display: none !important;
                                        }
                                        .rdrMonthAndYearWrapper {
                                            padding-top: 5px !important;
                                            height: 40px !important;
                                        }
                                        .rdrMonth {
                                            padding: 0 !important;
                                        }
                                    `}
                                    </style>
                                    <DateRange
                                        editableDateInputs={true}
                                        onChange={handleDateRangeChange}
                                        moveRangeOnFirstSelection={false}
                                        ranges={dateRange}
                                        maxDate={new Date()}
                                        months={1}
                                        direction="horizontal"
                                        className="date-range"
                                        staticRanges={[]}
                                        inputRanges={[]}
                                        rangeColors={['#0066ff']}
                                        minDate={new Date("2000-01-01")}
                                        showSelectionPreview={true}
                                        showMonthAndYearPickers={true}
                                        monthDisplayFormat="MMMM yyyy"
                                        dayDisplayFormat="d"
                                        showDateDisplay={false}
                                        monthsShown={1}
                                    />
                                    <div className="d-flex justify-content-end mt-2">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={clearDateFilter}
                                        >
                                            Clear
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Filter Component */}
                        <div className="position-relative" ref={dropdownRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowDropdown(!showDropdown)}
                            >
                                <img src={Filter} alt="filter" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showDropdown && (
                                <div className="position-absolute end-0 mt-2 bg-white rounded shadow p-2"
                                    style={{ width: '200px', zIndex: 1000 }}>
                                    <Form>
                                        {filterOptions.map((option) => (
                                            <Form.Check
                                                key={option.value}
                                                type="checkbox"
                                                name="filterOption"
                                                id={`filter-${option.value}`}
                                                label={option.label}
                                                checked={selectedFilter === option.value}
                                                onChange={() => handleFilterChange(option.value)}
                                            />
                                        ))}
                                    </Form>
                                </div>
                            )}
                        </div>

                        {/* Create Button */}
                        <Button
                            variant="primary"
                            onClick={() => setShowCreate(true)}
                            className="bg-primary"
                            style={{ backgroundColor: '#4F46E5', border: 'none' }}
                        >
                            Create New Lessons
                        </Button>
                    </div>
                </div>
                <Row>
                    <Col sm="12">
                        <Card className="border-0 shadow-sm">
                            <CardBody className="p-0">
                                <DataTable
                                    columns={tableColumns}
                                    data={data}
                                    selectableRows
                                    pagination
                                    paginationServer={false}
                                    paginationTotalRows={totalRows}
                                    onChangePage={handlePageChange}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onSelectedRowsChange={handleRowSelected}
                                    clearSelectedRows={toggleDelete}
                                    progressPending={loading}
                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                    noDataComponent={
                                        <div className="text-center py-4 text-muted">
                                            No lessons found
                                        </div>
                                    }
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* CreateLesson component */}
            {showCreate && <CreateLesson
                show={showCreate}
                onHide={handleCreateClose}
                chapterId={chapterId}
                chapterTitle={chapterInfo.title}
            />}

            {/* EditLesson component */}
            {showEdit && <EditLesson
                show={showEdit}
                onHide={handleEditClose}
                lessonData={editRowData}
            />}

            <ConfirmationModal
                show={showModal}
                onHide={() => setShowModal(false)}
                onConfirm={handleModalConfirm}
                title="Are you sure?"
                message="You want to archive this lesson? Once archived, it will no longer be visible to users."
            />
        </Fragment>
    );
};

const ConfirmationModal = ({ show, onHide, onConfirm, title, message }) => (
    <Modal show={show} onHide={onHide} centered>
        <Modal.Body className="text-center p-4">
            <div className="mb-4">
                <div className="rounded-circle bg-warning bg-opacity-10 d-inline-flex p-4 mb-3">
                    <i className="bi bi-exclamation-lg fs-4 text-warning"></i>
                </div>
                <h4>{title}</h4>
                <p className="text-secondary mb-0">{message}</p>
            </div>
            <div className="d-flex gap-2 justify-content-center">
                <Button variant="primary" className="px-4" onClick={onConfirm}>Yes</Button>
                <Button variant="danger" className="px-4" onClick={onHide}>Cancel</Button>
            </div>
        </Modal.Body>
    </Modal>
);

export default LessonTable;